'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/table/style/css');

var _table = require('antd/lib/table');

var _table2 = _interopRequireDefault(_table);

var _css2 = require('antd/lib/message/style/css');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _css3 = require('antd/lib/button/style/css');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _constants = require('../constants');

var _shipping_template_form = require('./shipping_template_form');

var _shipping_template_form2 = _interopRequireDefault(_shipping_template_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShippingTemplateList = _react2.default.createClass({
    displayName: 'ShippingTemplateList',

    propTypes: {
        shippingTemplates: _react.PropTypes.object.isRequired
    },
    render: function render() {
        var columns = [{
            title: '运费模版名称',
            key: 'name',
            dataIndex: 'name'
        }, {
            title: '创建时间',
            key: 'created_at',
            dataIndex: 'created_at'
        }, {
            title: '操作',
            key: 'action',
            render: function render(text, record) {
                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { to: '/express/' + record.id },
                            _react2.default.createElement(
                                _button2.default,
                                null,
                                '\u7F16\u8F91'
                            )
                        ),
                        _react2.default.createElement('span', { className: 'ant-divider' }),
                        _react2.default.createElement(
                            _button2.default,
                            { onClick: function onClick() {
                                    _axios2.default.delete(record.id).then(function () {
                                        return _message2.default.info('操作成功');
                                    }).catch(function (error) {
                                        return _message2.default.error('\u64CD\u4F5C\u5931\u8D25\uFF1A' + error.data);
                                    });
                                } },
                            '\u5220\u9664'
                        )
                    )
                );
            }
        }];

        var shippingTemplates = this.props.shippingTemplates;
        var items = shippingTemplates.items,
            error = shippingTemplates.error,
            isFetching = shippingTemplates.isFetching;

        var pagination = Object.assign(_constants.PaginationConfig, {
            total: this.props.shippingTemplates.items.length,
            onChange: function onChange(current, pageSize) {
                // pageSize是undefined，有待研究

            },
            onShowSizeChange: function onShowSizeChange(current, pageSize) {

            }
        });
        var tableConfig = {
            columns: columns,
            locale: { emptyText: error && !error.ok ? '\u7F51\u7EDC\u9519\u8BEF\uFF1A' + error.statusText : '暂无数据' },
            dataSource: items,
            loading: isFetching,
            pagination: pagination,
            rowKey: function rowKey(record) {
                return record.id;
            }
        };

        return _react2.default.createElement(_table2.default, tableConfig);
    }
});

exports.default = ShippingTemplateList;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/shipping_template_list.js
// module id = 1547
// module chunks = 0